'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ui = require('../../constants/events/ui');

var _ui2 = _interopRequireDefault(_ui);

var _screen = require('./screen.view');

var _screen2 = _interopRequireDefault(_screen);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PLAYBACK_CHANGE_TIMEOUT = 300;
var SPACE_BAR_KEYCODE = 32;
var LEFT_ARROW_KEYCODE = 37;
var RIGHT_ARROW_KEYCODE = 39;
var UP_ARROW_KEYCODE = 38;
var DOWN_ARROW_KEYCODE = 40;
var AMOUNT_TO_SKIP_SECONDS = 5;
var AMOUNT_TO_CHANGE_VOLUME = 0.1;

var Screen = function () {
  function Screen(_ref) {
    var config = _ref.config,
        eventEmitter = _ref.eventEmitter,
        engine = _ref.engine,
        ui = _ref.ui;

    _classCallCheck(this, Screen);

    this._ui = ui;
    this._eventEmitter = eventEmitter;
    this._isInFullScreen = false;
    this.isHidden = false;
    this._engine = engine;
    this._delayedToggleVideoPlaybackTimeout = null;
    this.config = _extends({}, config);

    this._bindCallbacks();
    this._initUI();
    this.view.appendPlaybackViewNode(this._engine.getNode());
    this._bindEvents();
  }

  _createClass(Screen, [{
    key: '_bindCallbacks',
    value: function _bindCallbacks() {
      this._processNodeClick = this._processNodeClick.bind(this);
      this._processKeyboardInput = this._processKeyboardInput.bind(this);
      this._toggleVideoPlayback = this._toggleVideoPlayback.bind(this);
    }
  }, {
    key: '_initUI',
    value: function _initUI() {
      var config = {
        indicateScreenClick: this.config.indicateScreenClick,
        nativeControls: this.config.nativeControls,
        callbacks: {
          onWrapperKeyPress: this._processKeyboardInput
        }
      };

      if (!this.config.disableClickProcessing) {
        config.callbacks.onWrapperMouseClick = this._processNodeClick;
      }

      this.view = new _screen2.default(config);
    }
  }, {
    key: '_bindEvents',
    value: function _bindEvents() {
      this._eventEmitter.on(_ui2.default.FULLSCREEN_STATUS_CHANGED, this._setFullScreenStatus, this);
      this._eventEmitter.on(_ui2.default.PLAY_OVERLAY_TRIGGERED, this.view.focusOnNode, this.view);
    }
  }, {
    key: '_unbindEvents',
    value: function _unbindEvents() {
      this._eventEmitter.off(_ui2.default.FULLSCREEN_STATUS_CHANGED, this._setFullScreenStatus, this);
      this._eventEmitter.off(_ui2.default.PLAY_OVERLAY_TRIGGERED, this.view.focusOnNode, this.view);
    }
  }, {
    key: '_setFullScreenStatus',
    value: function _setFullScreenStatus(isInFullScreen) {
      this._isInFullScreen = isInFullScreen;
    }
  }, {
    key: '_processKeyboardInput',
    value: function _processKeyboardInput(e) {
      switch (e.keyCode) {
        case SPACE_BAR_KEYCODE:
          this._eventEmitter.emit(_ui2.default.ENGINE_CONTROL_THROUGH_KEYBOARD_TRIGGERED);
          this._showPlaybackChangeIndicator();
          this._toggleVideoPlayback();
          break;
        case LEFT_ARROW_KEYCODE:
          this._eventEmitter.emit(_ui2.default.ENGINE_CONTROL_THROUGH_KEYBOARD_TRIGGERED);
          this.view.activateRewindIcon();
          this._engine.goBackward(AMOUNT_TO_SKIP_SECONDS);
          break;
        case RIGHT_ARROW_KEYCODE:
          this._eventEmitter.emit(_ui2.default.ENGINE_CONTROL_THROUGH_KEYBOARD_TRIGGERED);
          this.view.activateForwardIcon();
          this._engine.goForward(AMOUNT_TO_SKIP_SECONDS);
          break;
        case UP_ARROW_KEYCODE:
          this._eventEmitter.emit(_ui2.default.ENGINE_CONTROL_THROUGH_KEYBOARD_TRIGGERED);
          this.view.activateIncreaseVolumeIcon();
          this._engine.increaseVolume(AMOUNT_TO_CHANGE_VOLUME);
          break;
        case DOWN_ARROW_KEYCODE:
          this._eventEmitter.emit(_ui2.default.ENGINE_CONTROL_THROUGH_KEYBOARD_TRIGGERED);
          this.view.activateDecreaseVolumeIcon();
          this._engine.decreaseVolume(AMOUNT_TO_CHANGE_VOLUME);
          break;
        default:
          break;
      }
    }
  }, {
    key: '_processNodeClick',
    value: function _processNodeClick() {
      if (this._delayedToggleVideoPlaybackTimeout) {
        clearTimeout(this._delayedToggleVideoPlaybackTimeout);
        this._delayedToggleVideoPlaybackTimeout = null;

        this._hideDelayedPlaybackChangeIndicator();

        this._toggleFullScreen();
      } else {
        this._showPlaybackChangeIndicator();
        this._delayedToggleVideoPlaybackTimeout = setTimeout(this._toggleVideoPlayback, PLAYBACK_CHANGE_TIMEOUT);
      }
    }
  }, {
    key: '_showPlaybackChangeIndicator',
    value: function _showPlaybackChangeIndicator() {
      if (this.config.indicateScreenClick) {
        var state = this._engine.getState();

        if (state === this._engine.STATES.PLAY_REQUESTED || state === this._engine.STATES.PLAYING) {
          this.view.activatePauseIcon();
        } else {
          this.view.activatePlayIcon();
        }
      }
    }
  }, {
    key: '_hideDelayedPlaybackChangeIndicator',
    value: function _hideDelayedPlaybackChangeIndicator() {
      if (this.config.indicateScreenClick) {
        this.view.deactivateIcon();
      }
    }
  }, {
    key: '_toggleVideoPlayback',
    value: function _toggleVideoPlayback() {
      this._delayedToggleVideoPlaybackTimeout = null;

      var state = this._engine.getState();

      if (state === this._engine.STATES.PLAY_REQUESTED || state === this._engine.STATES.PLAYING) {
        this._engine.pause();
      } else {
        this._engine.play();
      }
    }
  }, {
    key: '_toggleFullScreen',
    value: function _toggleFullScreen() {
      if (this._isInFullScreen) {
        this._exitFullScreen();
      } else {
        this._enterFullScreen();
      }
    }
  }, {
    key: 'hide',
    value: function hide() {
      if (!this.isHidden) {
        this.view.hide();
        this.isHidden = true;
      }
    }
  }, {
    key: 'show',
    value: function show() {
      if (this.isHidden) {
        this.view.show();
        this.isHidden = false;
      }
    }
  }, {
    key: '_enterFullScreen',
    value: function _enterFullScreen() {
      this._eventEmitter.emit(_ui2.default.FULLSCREEN_ENTER_TRIGGERED);
    }
  }, {
    key: '_exitFullScreen',
    value: function _exitFullScreen() {
      this._eventEmitter.emit(_ui2.default.FULLSCREEN_EXIT_TRIGGERED);
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this._unbindEvents();

      clearTimeout(this._delayedToggleVideoPlaybackTimeout);
      this.view.destroy();
      delete this.view;

      delete this._eventEmitter;
      delete this._engine;
      delete this._ui;
    }
  }, {
    key: 'node',
    get: function get() {
      return this.view.getNode();
    }
  }]);

  return Screen;
}();

Screen.View = _screen2.default;
exports.default = Screen;
//# sourceMappingURL=screen.controler.js.map



//////////////////
// WEBPACK FOOTER
// ./~/video-player/dist/src/ui/screen/screen.controler.js
// module id = 1233
// module chunks = 1 2 3